"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var languageSlice_1 = require("../../../features/languages/languageSlice");
var auth_1 = require("../../../helpers/auth");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var UpdatedToTopIcon = function (_a) {
    var isMobile = _a.isMobile, id = _a.id, isActive = _a.isActive, nextUpdatedToTop = _a.nextUpdatedToTop, onUpdateToTop = _a.onUpdateToTop, updateToTopCount = _a.updateToTopCount;
    var t = react_i18next_1.useTranslation('common').t;
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var isFavoriteUser = auth_1.getIsFavoriteUser();
    moment_1.default.locale(currentLanguage);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (isActive && Date.now() > Date.parse(nextUpdatedToTop)) ||
            isFavoriteUser ? (react_1.default.createElement("span", { onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                lodash_1.default.isFunction(onUpdateToTop) &&
                    onUpdateToTop(id, isFavoriteUser);
            } },
            react_1.default.createElement("i", { className: "cm-icon icon-arrow_up" }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: styles_module_scss_1.default.inactiveUpdateToTop, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                } }, isMobile ? (react_1.default.createElement("i", { className: classnames_1.default('cm-icon icon-arrow_up', styles_module_scss_1.default.inactiveIcon) })) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("i", { className: classnames_1.default('cm-icon icon-arrow_up', styles_module_scss_1.default.inactiveIcon) }),
                isActive && (react_1.default.createElement("div", { className: styles_module_scss_1.default.commentBoxOnHover },
                    t('MY_ANNOUNCEMENTS.UPDATE_TO_TOP'),
                    react_1.default.createElement("br", null),
                    moment_1.default(nextUpdatedToTop).format('LLLL')))))))),
        react_1.default.createElement("span", { className: styles_module_scss_1.default.update_to_top_count },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, updateToTopCount)))));
};
exports.default = UpdatedToTopIcon;
